import React from "react";
import { HiOutlineColorSwatch } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneArt } from "../../../lib/sysNavigation/SysNavigation";

type ArtRow = {
  art_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<ArtRow>
    type={_TYPES_.ART}
    title="Art"
    subtitle="Art content promoted on the public site."
    icon={<HiOutlineColorSwatch className="h-5 w-5" />}
    addRoute="/data/art/add"
    editRoute="/data/art/edit"
    pushOne={pushOneArt}
    dataKey="arts"
    countKey="artsCount"
    idField="art_id"
  />
);

export default Overview;
